import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
  duration?: number
}

export const LoadingSpinner: FC<Props> = ({
  size = 19,
  duration = 1.2,
  ...props
}) => {
  // 使用对象形式的样式代替内联的 <style> 标签
  const styles = {
    bar: {
      fill: 'white',
      fillOpacity: 0.1,
      animation: `fade ${duration}s linear infinite`,
    },
    // 为每个条形创建动画延迟
    barDelays: Array.from({ length: 12 }, (_, i) => ({
      animationDelay: `${i * 0.1}s`,
    })),
  }

  // 定义关键帧动画
  const keyframes = `
    @keyframes fade {
      0%   { fill-opacity: 1; }
      100% { fill-opacity: 0.1; }
    }
  `
  return (
    <>
      <style>{keyframes}</style>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[0] }}
            d="M6.99965 0C7.16842 0 7.33028 0.0670453 7.44962 0.186387C7.56896 0.305728 7.63601 0.46759 7.63601 0.636364V2.54546C7.63601 2.71423 7.56896 2.87609 7.44962 2.99543C7.33028 3.11478 7.16842 3.18182 6.99965 3.18182C6.83087 3.18182 6.66901 3.11478 6.54967 2.99543C6.43033 2.87609 6.36328 2.71423 6.36328 2.54546V0.636364C6.36328 0.46759 6.43033 0.305728 6.54967 0.186387C6.66901 0.0670453 6.83087 0 6.99965 0Z"
            fill="white"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[1] }}
            d="M10.5001 0.937794C10.6462 1.02218 10.7529 1.16118 10.7966 1.3242C10.8402 1.48721 10.8174 1.66091 10.733 1.80707L9.77843 3.46066C9.73695 3.53362 9.68145 3.59765 9.61513 3.64907C9.5488 3.70049 9.47296 3.73828 9.39196 3.76027C9.31097 3.78225 9.22643 3.78801 9.14321 3.77719C9.05998 3.76637 8.97972 3.7392 8.90704 3.69724C8.83436 3.65527 8.7707 3.59935 8.71972 3.53268C8.66874 3.46602 8.63146 3.38993 8.61001 3.30879C8.58856 3.22765 8.58336 3.14308 8.59473 3.05993C8.6061 2.97678 8.63381 2.8967 8.67625 2.8243L9.6308 1.1707C9.71519 1.02455 9.85418 0.917901 10.0172 0.874222C10.1802 0.830543 10.3539 0.853411 10.5001 0.937794Z"
            fill="white"
            fillOpacity="0.1"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[2] }}
            d="M13.062 3.50005C13.1464 3.64621 13.1693 3.8199 13.1256 3.98292C13.0819 4.14594 12.9752 4.28493 12.8291 4.36932L11.1755 5.32387C11.0294 5.40693 10.8564 5.42883 10.6942 5.3848C10.5321 5.34077 10.3939 5.23438 10.3099 5.08886C10.2258 4.94333 10.2028 4.77047 10.2457 4.60801C10.2887 4.44555 10.3942 4.30667 10.5391 4.22169L12.1927 3.26714C12.3389 3.18276 12.5126 3.15989 12.6756 3.20357C12.8386 3.24725 12.9776 3.35389 13.062 3.50005Z"
            fill="white"
            fillOpacity="0.2"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[3] }}
            d="M14.0002 7.00013C14.0002 7.0837 13.9837 7.16645 13.9517 7.24366C13.9198 7.32087 13.8729 7.39102 13.8138 7.45011C13.7547 7.5092 13.6845 7.55608 13.6073 7.58806C13.5301 7.62004 13.4474 7.6365 13.3638 7.6365H11.4547C11.2859 7.6365 11.1241 7.56945 11.0047 7.45011C10.8854 7.33077 10.8184 7.16891 10.8184 7.00013C10.8184 6.83136 10.8854 6.6695 11.0047 6.55016C11.1241 6.43081 11.2859 6.36377 11.4547 6.36377H13.3638C13.4474 6.36377 13.5301 6.38023 13.6073 6.41221C13.6845 6.44419 13.7547 6.49106 13.8138 6.55016C13.8729 6.60925 13.9198 6.6794 13.9517 6.75661C13.9837 6.83381 14.0002 6.91657 14.0002 7.00013Z"
            fill="white"
            fillOpacity="0.3"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[4] }}
            d="M13.0625 10.5001C12.9781 10.6462 12.8391 10.7529 12.6761 10.7966C12.5131 10.8402 12.3394 10.8174 12.1932 10.733L10.5396 9.77843C10.4667 9.73695 10.4026 9.68145 10.3512 9.61513C10.2998 9.5488 10.262 9.47296 10.24 9.39196C10.218 9.31097 10.2123 9.22643 10.2231 9.14321C10.2339 9.05998 10.2611 8.97972 10.303 8.90704C10.345 8.83436 10.4009 8.7707 10.4676 8.71972C10.5343 8.66874 10.6103 8.63146 10.6915 8.61001C10.7726 8.58856 10.8572 8.58336 10.9403 8.59473C11.0235 8.6061 11.1036 8.63381 11.176 8.67625L12.8296 9.6308C12.9757 9.71519 13.0824 9.85418 13.126 10.0172C13.1697 10.1802 13.1469 10.3539 13.0625 10.5001Z"
            fill="white"
            fillOpacity="0.4"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[5] }}
            d="M10.4998 13.0622C10.3536 13.1466 10.1799 13.1695 10.0169 13.1258C9.85386 13.0821 9.71487 12.9755 9.63048 12.8293L8.67594 11.1757C8.59288 11.0297 8.57098 10.8567 8.61501 10.6945C8.65904 10.5323 8.76542 10.3941 8.91095 10.3101C9.05648 10.2261 9.22933 10.203 9.39179 10.246C9.55426 10.2889 9.69313 10.3944 9.77812 10.5394L10.7327 12.193C10.817 12.3391 10.8399 12.5128 10.7962 12.6758C10.7526 12.8389 10.6459 12.9779 10.4998 13.0622Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[6] }}
            d="M6.99965 13.9999C6.91608 13.9999 6.83333 13.9835 6.75612 13.9515C6.67891 13.9195 6.60876 13.8726 6.54967 13.8135C6.49058 13.7545 6.4437 13.6843 6.41172 13.6071C6.37974 13.5299 6.36328 13.4471 6.36328 13.3636V11.4545C6.36328 11.2857 6.43033 11.1238 6.54967 11.0045C6.66901 10.8852 6.83087 10.8181 6.99965 10.8181C7.16842 10.8181 7.33028 10.8852 7.44962 11.0045C7.56896 11.1238 7.63601 11.2857 7.63601 11.4545V13.3636C7.63601 13.4471 7.61955 13.5299 7.58757 13.6071C7.55559 13.6843 7.50871 13.7545 7.44962 13.8135C7.39053 13.8726 7.32038 13.9195 7.24317 13.9515C7.16596 13.9835 7.08321 13.9999 6.99965 13.9999Z"
            fill="white"
            fillOpacity="0.6"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[7] }}
            d="M3.49981 13.0622C3.35365 12.9778 3.247 12.8389 3.20332 12.6758C3.15965 12.5128 3.18251 12.3391 3.2669 12.193L4.22144 10.5394C4.26292 10.4664 4.31842 10.4024 4.38475 10.351C4.45108 10.2995 4.52692 10.2617 4.60791 10.2398C4.6889 10.2178 4.77344 10.212 4.85667 10.2228C4.93989 10.2337 5.02015 10.2608 5.09283 10.3028C5.16551 10.3448 5.22917 10.4007 5.28015 10.4673C5.33113 10.534 5.36842 10.6101 5.38987 10.6912C5.41132 10.7724 5.41651 10.857 5.40514 10.9401C5.39377 11.0233 5.36607 11.1033 5.32362 11.1757L4.36908 12.8293C4.28469 12.9755 4.1457 13.0821 3.98268 13.1258C3.81966 13.1695 3.64596 13.1466 3.49981 13.0622Z"
            fill="white"
            fillOpacity="0.7"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[8] }}
            d="M0.937794 10.5C0.853411 10.3538 0.830543 10.1801 0.874222 10.0171C0.917901 9.85411 1.02455 9.71512 1.1707 9.63073L2.8243 8.67618C2.97038 8.59312 3.14338 8.57122 3.30556 8.61525C3.46773 8.65928 3.6059 8.76567 3.68993 8.91119C3.77395 9.05672 3.797 9.22958 3.75405 9.39204C3.7111 9.5545 3.60563 9.69338 3.46066 9.77836L1.80707 10.7329C1.66091 10.8173 1.48721 10.8402 1.3242 10.7965C1.16118 10.7528 1.02218 10.6462 0.937794 10.5Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[9] }}
            d="M0 7.00013C0 6.83136 0.0670453 6.6695 0.186387 6.55016C0.305728 6.43081 0.46759 6.36377 0.636364 6.36377H2.54546C2.71423 6.36377 2.87609 6.43081 2.99543 6.55016C3.11478 6.6695 3.18182 6.83136 3.18182 7.00013C3.18182 7.16891 3.11478 7.33077 2.99543 7.45011C2.87609 7.56945 2.71423 7.6365 2.54546 7.6365H0.636364C0.46759 7.6365 0.305728 7.56945 0.186387 7.45011C0.0670453 7.33077 0 7.16891 0 7.00013Z"
            fill="white"
            fillOpacity="0.9"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[10] }}
            d="M0.937794 3.50005C1.02218 3.35389 1.16118 3.24725 1.3242 3.20357C1.48721 3.15989 1.66091 3.18276 1.80707 3.26714L3.46066 4.22169C3.53362 4.26317 3.59765 4.31867 3.64907 4.38499C3.70049 4.45132 3.73828 4.52716 3.76027 4.60816C3.78225 4.68915 3.78801 4.77369 3.77719 4.85691C3.76637 4.94014 3.7392 5.0204 3.69724 5.09308C3.65527 5.16576 3.59935 5.22942 3.53268 5.2804C3.46602 5.33137 3.38993 5.36866 3.30879 5.39011C3.22765 5.41156 3.14308 5.41676 3.05993 5.40539C2.97678 5.39402 2.8967 5.36631 2.8243 5.32387L1.1707 4.36932C1.02455 4.28493 0.917901 4.14594 0.874222 3.98292C0.830543 3.8199 0.853411 3.64621 0.937794 3.50005Z"
            fill="white"
          />
          <path
            className="bar"
            style={{ ...styles.bar, ...styles.barDelays[11] }}
            d="M3.49981 0.937794C3.64596 0.853411 3.81966 0.830543 3.98268 0.874222C4.1457 0.917901 4.28469 1.02455 4.36908 1.1707L5.32362 2.8243C5.40668 2.97038 5.42858 3.14338 5.38456 3.30556C5.34053 3.46773 5.23414 3.6059 5.08861 3.68993C4.94308 3.77395 4.77023 3.797 4.60777 3.75405C4.44531 3.7111 4.30643 3.60563 4.22144 3.46066L3.2669 1.80707C3.18251 1.66091 3.15965 1.48721 3.20332 1.3242C3.247 1.16118 3.35365 1.02218 3.49981 0.937794Z"
            fill="white"
          />
        </g>
      </svg>
    </>
  )
}
